import { useState, useRef } from "react";
import {
  FaBell,
  FaSearch,
  FaCog,
  FaPlane,
  FaHotel,
  FaBoxOpen,
  FaCreditCard,
  FaBolt,
  FaCode,
  FaFileAlt,
  FaWallet,
  FaShieldAlt,
  FaUsers,
  FaChartBar,
} from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";
import { HiChevronDown } from "react-icons/hi";

const menuItems = [
  { icon: FaChartBar, label: "Report Summary", id: "summary" },
  { icon: FaPlane, label: "Flights", id: "flights" },
  { icon: FaHotel, label: "Hotels", id: "hotels" },
  { icon: MdLocationPin, label: "Tours", id: "tours" },
  { icon: FaBoxOpen, label: "Nobi Packages", id: "packages" },
  { icon: FaCreditCard, label: "Subscriptions", id: "subscriptions" },
  { icon: FaBolt, label: "TravX", id: "travx" },
  { icon: FaCode, label: "API", id: "api" },
  { icon: FaFileAlt, label: "Post-Ticketing", id: "post-ticketing" },
  { icon: FaWallet, label: "Wallet", id: "wallet" },
  { icon: FaShieldAlt, label: "Insurance", id: "insurance" },
  { icon: FaUsers, label: "Agents", id: "agents" },
];

export function TopNav({ activeView, onViewChange }) {
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const moreButtonRef = useRef(null);

  const primaryItems = menuItems.slice(0, 7);
  const moreItems = menuItems.slice(7);

  const handleMoreClick = () => {
    if (!moreMenuOpen && moreButtonRef.current) {
      const rect = moreButtonRef.current.getBoundingClientRect();
      // Align dropdown to the right of the button, with width of 56 (14rem = 224px)
      const dropdownWidth = 224;
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 4, // +4px for mt-1 equivalent
        left: rect.right + window.scrollX - dropdownWidth,
      });
    }
    setMoreMenuOpen(!moreMenuOpen);
  };

  const handleClose = () => setMoreMenuOpen(false);

  return (
    <header className="bg-white border-b border-gray-200">
      {/* Navigation row */}
      <nav className="h-14 flex items-center justify-evenly px-6 gap-1 overflow-x-auto">
        {primaryItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeView === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all whitespace-nowrap ${
                isActive
                  ? "bg-[#1E61DC] text-white shadow-md"
                  : "text-[#6B7280] hover:bg-gray-50 hover:text-[#1A1A1A]"
              }`}
            >
              <Icon size={16} />
              <span className="text-sm font-medium">{item.label}</span>
            </button>
          );
        })}

        {/* More dropdown */}
        <div>
          <button
            ref={moreButtonRef}
            onClick={handleMoreClick}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all whitespace-nowrap ${
              moreItems.some((i) => i.id === activeView)
                ? "bg-[#1E61DC] text-white shadow-md"
                : "text-[#6B7280] hover:bg-gray-50 hover:text-[#1A1A1A]"
            }`}
          >
            <span className="text-sm font-medium">More</span>
            <HiChevronDown size={16} />
          </button>

          {moreMenuOpen && (
            <>
              {/* Backdrop to close on outside click */}
              <div
                className="fixed inset-0 z-10"
                onClick={handleClose}
              />
              {/* Dropdown menu with fixed positioning */}
              <div
                className="fixed w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20"
                style={{
                  top: `${dropdownPosition.top}px`,
                  left: `${dropdownPosition.left}px`,
                }}
              >
                {moreItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = activeView === item.id;

                  return (
                    <button
                      key={item.id}
                      onClick={() => {
                        onViewChange(item.id);
                        handleClose();
                      }}
                      className={`w-full flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors ${
                        isActive
                          ? "bg-[#1E61DC]/10 text-[#1E61DC]"
                          : "text-[#6B7280]"
                      }`}
                    >
                      <Icon size={16} />
                      <span className="text-sm font-medium">{item.label}</span>
                    </button>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}